import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import { hasPermission } from 'src/utils/JWT';
import { useContextSelector } from 'use-context-selector';
import {
  convertMultiButtonPermission,
  convertSingleButtonPermission,
  EditIconPermissions,
  EditPeriodButtonPermissions,
  EditPeriodsButtonPermissions,
  ViewPeriodPermissions,
} from '../view_invoice_budget_period';
import { getEditPeriodsButtonText, InvoiceContext } from './InvoiceDetailsContext';

const EditPeriods = () => {
  const isInvoiceDirty = useContextSelector(InvoiceContext, (value) => value.isInvoiceDirty);
  const isEditPeriodDisable = useContextSelector(
    InvoiceContext,
    (value) => value.isEditPeriodDisable
  );
  const editPeriodErrorMessage = useContextSelector(
    InvoiceContext,
    (value) => value.editPeriodErrorMessage
  );

  const mpaPermissionNumber = useContextSelector(
    InvoiceContext,
    (value) => value.mpaPermissionNumber
  );
  const handleOpenSidePanel = useContextSelector(
    InvoiceContext,
    (value) => value.handleOpenSidePanel
  );

  const isEditIconVisible = hasPermission(EditIconPermissions, mpaPermissionNumber);
  const isViewIconVisible = hasPermission(ViewPeriodPermissions, mpaPermissionNumber);
  const isEditPeriodsTxt = hasPermission(EditPeriodsButtonPermissions, mpaPermissionNumber);
  const isEditPeriodTxt = hasPermission(EditPeriodButtonPermissions, mpaPermissionNumber);
  const isConvertPeriodsTxt = hasPermission(convertMultiButtonPermission, mpaPermissionNumber);
  const isConvertPeriodTxt = hasPermission(convertSingleButtonPermission, mpaPermissionNumber);

  const title = getEditPeriodsButtonText(
    isEditPeriodsTxt,
    isEditPeriodTxt,
    isConvertPeriodsTxt,
    isConvertPeriodTxt
  );

  return (
    <>
      {isEditIconVisible ? (
        <PopUp
          show={isEditPeriodDisable}
          content={
            <div className="m-1 max-w-[300px]">
              <PopUpContentWrapper type="Error" contents={editPeriodErrorMessage} />
            </div>
          }
        >
          <Button onClick={handleOpenSidePanel} color="info" disabled={isEditPeriodDisable}>
            {title}
          </Button>
        </PopUp>
      ) : (
        ''
      )}

      {isViewIconVisible ? (
        <Button onClick={handleOpenSidePanel} color="info" disabled={isInvoiceDirty}>
          View Periods
        </Button>
      ) : (
        ''
      )}
    </>
  );
};

export default EditPeriods;
